import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {SellingReportService} from "../../report/service/sellingReport.service";
import {SellingReport} from "../../models/sellingReport";
import {SellingReportItem} from "../../models/sellingReportItem";

@Injectable()
export class ProductTotalSummaryResolve implements Resolve<SellingReport> {
    constructor(private sellingReportService: SellingReportService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<SellingReport> {
        return this.sellingReportService.getProductTotalSummary(route.params.id);
    }
}
